// Mini player: a tab bar accessory (like Apple Music's) while a sound plays, on every tab but Today,
// which has the big soothe button. Tap the text to open Sounds, the button to stop.
import { Link, useLocation } from 'react-router';
import { useSound } from './SoundProvider';
import { soundById } from './catalog';

export function MiniPlayer() {
  const snd = useSound();
  const loc = useLocation();
  if (!snd.playing || loc.pathname === '/' || loc.pathname.startsWith('/sounds')) return null;
  const s = soundById(snd.soundId);
  return (
    <div className="mini-player lg" role="region" aria-label="Now playing">
      <span className="mp-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 12c2-4 4-4 6 0s4 4 6 0 4-4 6 0" /></svg></span>
      <Link className="mp-text" to="/sounds"><b>{s.name}</b><span>{snd.timerMin ? snd.timerLabel() : 'No timer'}</span></Link>
      <button type="button" aria-label={`Stop ${s.name}`} onClick={() => snd.stop('user')}>
        <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1.5" /><rect x="14" y="5" width="4" height="14" rx="1.5" /></svg>
      </button>
    </div>
  );
}
